import React from 'react';
import './ContentPrograms.css';
import ContentProgramsNoActivePrograms from './ContentPrograms/ContentProgramsNoActivePrograms';
import ContentProgramsDetails from './ContentPrograms/ContentProgramsDetails';
import ContentProgramsListNew from './ContentPrograms/ContentProgramsListNew';

function ContentPrograms() {

  return (
    <>
        <section className='ContentPrograms'>
         
            {/* <ContentProgramsNoActivePrograms /> */}

            {/* <ContentProgramsDetails /> */}

            <ContentProgramsListNew />

        </section>


        
    </>
  );
}

export default ContentPrograms;
